
import React from 'react';
import { Message } from '@/types/chat';
import { cn } from '@/lib/utils';

interface RepliedMessageDisplayProps {
  repliedMessage: Message;
  senderName?: string;
  isCurrentUserMessage: boolean;
}

export const RepliedMessageDisplay: React.FC<RepliedMessageDisplayProps> = ({
  repliedMessage,
  senderName,
  isCurrentUserMessage
}) => {
  const getContentPreview = (message: Message) => {
    if (message.deleted_at) {
      return 'Mensagem apagada';
    }
    
    switch (message.content_type) {
      case 'text':
        return message.content || '';
      case 'image':
        return '📷 Imagem';
      case 'audio':
        return '🎵 Áudio';
      default:
        return 'Mensagem';
    }
  };

  return (
    <div className={cn(
      "border-l-2 pl-3 py-1 mb-2 text-xs opacity-80 max-w-[calc(100vw-6rem)] overflow-hidden break-words",
      isCurrentUserMessage 
        ? "border-white/30 bg-white/5" 
        : "border-luxury-red/50 bg-luxury-red/5"
    )}>
      <div className="font-medium text-white/90 truncate">
        {senderName || 'Usuário'}
      </div>
      <div className={cn(
        "mt-1 truncate",
        repliedMessage.deleted_at ? "italic text-white/50" : "text-white/70"
      )}>
        {getContentPreview(repliedMessage)}
      </div>
    </div>
  );
};
